import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from "react-router-dom";
import { getSearchDetail } from '../../../../api/repositories';
import { setInvalidToken } from '../../../../redux/features/main/invalidTokenSlice'
import { dataViewAll } from '../constant'

const useActions = () => {
    const dispatch = useDispatch()
    const searchBarPosition = useSelector((state) => state.search.searchBarPosition);
    var numb = 1;
    let [ searchParams, setSearchParams ] = useSearchParams();

    const [ dataCategoryAll, setDataCategoryAll ] = useState([]);
    const [ paginationNumb, setPaginationNumb ] = useState(1)
    const [ reachEnd, setReachEnd ] = useState(false)
    const [ reachBottom, setReachBottom ] = useState(false)

    const fetchCategoryAll = async() => {

        const typeParam = searchBarPosition !== '' ? searchBarPosition === 'search_mylj' ? '' : 'academy' : '';
        const maxLazyLoadLimit = 15;
        const paramSearch = `?keyword=${searchParams.get('search')}&type=${typeParam}&page=${paginationNumb}&value=${searchParams.get("all")}&limit=${maxLazyLoadLimit}`

        try {
            const { data, status } = await getSearchDetail(paramSearch);
            dispatch(setInvalidToken(status))
            // const { data } = dataViewAll;
            if(data.data.length > 0){
                setDataCategoryAll((prevData) => [...prevData, ...data.data]);
            } else {
                // set if lazy load already Reach End of Data
                if(paginationNumb > 1) setReachEnd(true);
            }
        } catch (err) {
            console.log("Error Fetch Search Category All ",err);
            setDataCategoryAll([]);
        } finally {
            setReachBottom(false)
        }
    }

    useEffect(() => {
        if(
            searchParams.get("all") !== undefined && 
            searchParams.get("all") !== "" && 
            searchParams.get("all") !== null
          ){
            if(reachEnd === false) fetchCategoryAll()
          }
    },[searchParams, paginationNumb])

    // useEffect for check if scrollbar already Reach Bottom
    useEffect(() => {
        var elmain = document.getElementById("content-main")
        const onscroll = () => {
            var obj = document.getElementById("content-main")
            if (
                obj.scrollHeight - obj.scrollTop - obj.clientHeight < 1
            ) {
                console.log("reached bottom = "+numb);
                numb++;
                setPaginationNumb(numb);
                setReachBottom(true);
            }
          };

          
        elmain.addEventListener("scroll", onscroll);
        return () => {
          elmain.removeEventListener("scroll", onscroll);
        };
      }, []);


    return{
        dataCategoryAll,
        reachEnd,
        reachBottom
    }
}

export default useActions